import { render, staticRenderFns } from "./players-winners-rtp-distribution.vue?vue&type=template&id=e3b895ec&scoped=true&"
import script from "./players-winners-rtp-distribution.vue?vue&type=script&lang=js&"
export * from "./players-winners-rtp-distribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b895ec",
  null
  
)

export default component.exports